import ProductConfig from './data'
const fileType = {
  docType: '8' // 文书图片
}

const docType = {
  check: '1' // 文书审核类型
}

const payType = {
  aliPay: '0', // 支付宝支付
  wxPay: '1' // 微信H5支付
}

const orderType = {
  tel: 'SC17001',
  doc: 'SC18001'
}

const chargeType = {
  byTime: '2',
  byPer: '1'
}

const productType = {
  timeCard: '3', // 时长卡
  annualCard: '2'// 年卡
}

const couponType = {
  moneyDiscount: '1',
  timeDiscount: '2',
  timesDiscount: '3'
}

const serviceType = {
  tel: 1, // 电话咨询
  card: 2, // 会员卡
  contractDown: 3, // 合同下载
  contractReview: 4 // 合同评审
}

const productCode = {
  minTimeCard: 'PC18003', //  10分钟时长卡
  langTimeCard: 'PC18004', // 15分钟时长卡
  changtCard: 'MC15001', // 畅听卡
  changxCard: 'MC15002', // 畅享卡
  phoneCall: 'SC17001', // 电话咨询
  docCheck: 'SC18001', // 文书审查
  docDraft: 'SC18004', // 文书审查
  docModule: 'SC18002', // 文书模板
  faceConsult: 'SC19001', // 见面咨询
  lawyerLetter: 'SC19002', // 发律师函
  lawsuit: 'SC19003', // 代打官司
  goldCard: 'MC19001', // 金卡
  platinum: 'MC19002', // 白金卡
  singleCard: 'PC15001', // 次卡,
  goldMonth: 'MC19003', // 金卡月卡
  goldQuarter: 'MC19004', // 金卡季卡
  goldHalf: 'MC19004', // 金卡半年卡
  threeTimesCard: 'PC15001' // 律师咨询次卡（3次
}

/**
 * 订单状态
 */
const orderStatus = {
  newSubmit: '1', // 新提交
  isService: '2', // 服务中
  unPay: '3', // 待支付
  evaluated: '4', // 待评价
  finish: '5', // 已完成
  cancel: '99' // 已取消
}

/**
 * 订单状态
 */
const consultStatus = {
  over: '6' // 通话完成

}

/**
 * 文书订单详情状态
 */
const docOrderType = {
  await: '1',
  checking: '2',
  checked: '3'
}

/**
 * 交互方式
 * @type {{page: number, pop: number}}
 */
const mode = {
  page: 1, // 页面
  pop: 2 // 弹框
}

const bannerType = {
  header: 1,
  body: 2,
  middle: 3
}

const isMember = 1 // 会员

const listStep = function (type) {
  let list
  switch (type) {
    case 'docModule': list = ['成为会员', '选择模板', '导出邮箱', '邮箱验收']; break
    case 'docCheck': list = ['提交订单', '律师报价', '律师审查', '查看结果']; break
    case 'faceConsult':list = ['立即下单', '填写信息', '确认支付', '安排律师', '见面咨询']; break
    case 'lawyerLetter':list = ['立即下单', '填写信息', '确认支付', '安排律师', '发律师函']; break
    case 'lawsuit':
    case 'draftDoc':
      list = ['立即下单', '填写信息', '支付订金', '安排律师', '律师服务']; break
  }
  return list
}

const getOrderStatusName = function (status) {
  console.log('getOrderStatusName status', status)
  let name = ''
  switch (status) {
    case orderStatus.newSubmit: name = '等待服务'; break
    case orderStatus.isService: name = '服务中'; break
    case orderStatus.unPay: name = '待支付'; break
    case orderStatus.finish: name = '已完成'; break
    case orderStatus.cancel: name = '已取消'; break
  }
  return name
}

const getServiceTypeName = function (typeValue) {
  let name = ''
  switch (typeValue) {
    case serviceType.tel: name = '电话咨询'; break
    case serviceType.card: name = '会员卡'; break
    case serviceType.contractDown: name = '合同下载'; break
    case serviceType.contractReview: name = '合同评审'; break
  }
  return name
}

export const data = {
  fileType,
  docType,
  payType,
  productType,
  orderType,
  chargeType,
  isMember,
  mode,
  bannerType,
  orderStatus,
  docOrderType,
  productCode,
  consultStatus,
  getServiceTypeName,
  getOrderStatusName,
  listStep,
  couponType,
  ProductConfig
}
export default data



// WEBPACK FOOTER //
// ./src/const/index.js